<template>
  <div class="page-template">
       <div class="page-title">{{ title }}</div>
        <search-form-template
      ref="storeTemplate"
      :searchOptions="storeSearchOptions"
      @searchSubmit="searchSubmit"
      @clear="clearSearch"
      @btnCommon="btnCommon"
    ></search-form-template>
      <div class="goods-data">
           <div class="goods-data-data" v-for="(v,i) in datalist" :key="i">
            <div :style="{color:v.color}">0</div>
            <span>{{ v.data }}</span>
          </div>
      </div>
      <div class="echarbox">
            <div class="chartsbox-list">
          <span>会员概况</span>
          <div class="data-range">
             <search-form-template
               :searchOptions="memberSearchOptions"
                 @searchSubmit="membersearchSubmit"
                @clear="clearSearch"
                @btnCommon="memberbtnCommon"
            ></search-form-template>
          </div>
          <div class="echartsArea1">
               <div class="member-detail" v-for="(v,i) in memberData" :key="i">
                    <div class="sale-data">
                        <h3>{{v.leftNumber}}</h3>
                        <span>{{v.leftData}}</span>
                    </div>
                   <div class="progressbar">
                       <div class="progressbar-top">
                            <p>{{v.proNewData}}</p><span>{{v.proNewNum}}</span>
                       </div>
                       <el-progress :percentage="0" ></el-progress>
                       <div class="progressbar-top">
                           <p>{{v.proOldData}}</p><span>{{v.propOldNum}}</span>
                       </div>
                       <el-progress :percentage="0"  ></el-progress>
                       <div class="progressbar-top">
                            <p>{{v.yearInYear}}</p><span>{{v.chain}}</span>
                       </div>
                   </div>
               </div>
          </div>
        </div>
          <div class="chartsbox-list">
          <span>会员排名</span>
          <div class="data-range">
                <el-tabs v-model="activeTab">
                <el-tab-pane label="按消费金额" name="saleNumber" >
                            <table-template ref="saleNumber"
                                :tableOptions="saleNumberTable" >
                            </table-template>
                </el-tab-pane>
                <el-tab-pane label="按充值金额" name="payNumber">
                        <table-template ref="payNumber"
                                    :tableOptions="payNumberTable"
                        ></table-template>
                </el-tab-pane>
                </el-tabs>
          </div>
        </div>
      </div>
      <div class="echartMessage">
          <div class="echartMessage-list">
              <span>商品分类消费排名</span>
               <div>
               <search-form-template
                ref="goodsCumouser"
               :searchOptions="goodsRankSearchOptions"
                @searchSubmit="goodssearchSubmit"
                @clear="goodsclearSearch"
                @btnCommon="goodsbtnCommon"
            ></search-form-template>
            <div class="memberArea">
                 <div class="memberArea-list">
                     <span>客单价分布统计</span>
                     <echarts-template  class="charts-box-category" ref="customerListEcharts"
                         :picOption="customerListEcharts">
                     </echarts-template>
                 </div>

                 <div class="memberArea-list">
                      <span>等级分布统计</span>
                      <echarts-template  class="charts-box-category" ref="levelEcharts"
                         :picOption="levelEcharts">
                     </echarts-template>
                 </div>
                 <div class="memberArea-list">
                      <span>会员消费次数统计</span>
                      <echarts-template  class="charts-box-category" ref="mConsumptionEcharts"
                         :picOption="mConsumptionEcharts">
                     </echarts-template>
                 </div>
                 <div class="memberArea-list">
                      <span>消费密集度分布统计</span>
                      <echarts-template  class="charts-box-category" ref="intensityEcharts"
                         :picOption="intensityEcharts">
                     </echarts-template>
                 </div>
                 <!-- <div class="memberArea-list">
                      <span>年龄分布与消费金额</span>
                       <el-tabs v-model="ageTab" >
                        <el-tab-pane label="人数" name="agePerson" >
                            <div class="agePerson">
                                <echarts-template  class="charts-box-agePerson" ref="agePersonEcharts"
                                   :picOption="agePersonEcharts">
                                </echarts-template>
                               <list-template
                                :tableOptions="apersonTableOptions"
                                :tableData="apersonTableData"
                                ></list-template>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="金额" name="ageMoney">
                                <div class="agePerson">
                                <echarts-template  class="charts-box-ageMoney" ref="ageMoneyEcharts"
                                   :picOption="ageMoneyEcharts">
                                </echarts-template>
                               <list-template
                                :tableOptions="amoneyTableOptions"
                                :tableData="amoneyTableData"
                                ></list-template>
                            </div>
                        </el-tab-pane>
                        </el-tabs>
                 </div> -->
                 <!-- <div class="memberArea-list">
                      <span>性别比例与消费金额</span>
                      <el-tabs v-model="sexTab" >
                        <el-tab-pane label="人数" name="sexPerson" >
                            <div class="agePerson">
                                <echarts-template  class="charts-box-agePerson" ref="sexPersonEcharts"
                                   :picOption="sexPersonEcharts">
                                </echarts-template>
                               <list-template
                                :tableOptions="spersonTableOptions"
                                :tableData="spersonTableData"
                                ></list-template>
                            </div>

                        </el-tab-pane>
                        <el-tab-pane label="金额" name="sexMoney">
                                <div class="agePerson">
                                <echarts-template  class="charts-box-ageMoney" ref="sexMoneyEcharts"
                                   :picOption="sexMoneyEcharts">
                                </echarts-template>
                               <list-template
                                :tableOptions="smoneyTableOptions"
                                :tableData="smoneyTableData"
                                ></list-template>
                            </div>
                        </el-tab-pane>
                        </el-tabs>
                 </div> -->
                  <div class="memberArea-list">
                       <span>门店会员数据统计</span>
                       <div class="storeMember">
                            <table-template ref="storeMember"
                                        :tableOptions="storeMemberTable">
                            </table-template>
                       </div>

                 </div>
            </div>
          </div>
          </div>
      </div>
  </div>
</template>

<script>
import api from "@/config/api";
import tableTemplate from '@/components/template/tableTemplate';
import searchFormTemplate from '@/components/template/searchFormTemplate';
import echartsTemplate from "@/components/controls/echarts";
import listTemplate from "@/components/template/listTemplate";
import userPower from "@/mixin/userPower";
import {customerListEcharts,
        levelEcharts,
        mConsumptionEcharts,
        intensityEcharts,agePersonEcharts,
        ageMoneyEcharts,sexPersonEcharts,
        sexMoneyEcharts}from "@/page/home/options/reportEcharts";
export default {
    mixins: [userPower],
    components:{searchFormTemplate,tableTemplate,echartsTemplate,listTemplate},
  created(){
      this.setStore(this.storeSearchOptions.simple);
      this.allStore()
      this.memberForword(this.result)
      this.getCustomerList(this.param),
      this.getLevel(this.param),
      this.getmConsumption(this.param),
      this.getIntensity(this.param)
      this.getMemberData(this.param)
    
    //   this.getAgePerson(),
    //   this.getAgeMoney(),
    //   this.getSexPerson(),
    //   this.getSexMoney()
  },
  mounted(){
       this.$refs["storeMember"].searchSubmit(this.param)
       this.title = document.title;
  },
  data(){
        let stCreateDttm = this.$moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
       let edCreateDttm = this.$moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
        let defaultParam = { stCreateDttm: stCreateDttm, edCreateDttm: edCreateDttm};
      return {
          dateType:"",
          goodsParam:"",
          title:"",
          activeTab:"saleNumber",
          ageTab:'agePerson',
          sexTab:'sexPerson',
          param:defaultParam,
          customerListEcharts,
          mConsumptionEcharts,
          intensityEcharts,
          agePersonEcharts,
          levelEcharts,
          ageMoneyEcharts,
          sexPersonEcharts,
          sexMoneyEcharts,
          amoneyTableData:[],
          apersonTableData:[],
          smoneyTableData:[],
          spersonTableData:[],
          percentage:100,
          memberData:[
             {
                leftNumber :'0.00',
                leftData:"总交易额（元）",
                proNewData:'新会员交易额（元）',
                proNewNum:'0.00',
                proOldData:"老会员交易额（元）",
                propOldNum:"0.00",
                yearInYear:"同比:0%",
                chain:"0%"
             },
             {
                leftNumber:'0.00',
                leftData:"交易订单（笔）",
                proNewData:'新会员订单数（笔）',
                proNewNum:'0.00',
                proOldData:"老会员订单数（笔）",
                propOldNum:"0",
                yearInYear:"同比:0%",
                chain:'环比:0%'
             },
             {
                leftNumber:'0.00',
                leftData:"充值金额（元）",
                proNewData:'新会员充值额（元）',
                proNewNum:'0.00',
                proOldData:"老会员充值额（元）",
                propOldNum:"0.00",
                yearInYear:"同比:0%",
                chain:"0%"
             },
              {
                 leftNumber:'0.00',
                leftData:"客价单（元）",
                proNewData:'新会员客单价（元）',
                proNewNum:'0.00',
                proOldData:"老会员客价单（元）",
                propOldNum:"0.00",
                yearInYear:"同比:0%",
                chain:"0%"
             },
         ],
        storeSearchOptions: {
          simple: [
            {
              label: '门店名称',
              type: 'select',
              prop: 'storeId',
              data: [],
              span: 24
            },
          ],
        },
          datalist:[
              {data: "会员总数（个）", color: "#5f58e6"},
              {data: "会员总余额（元）", color: "#5f58e6"},
              {data: "新增会员（个）", color: "#5f58e6"},
          ],
        saleNumberTable:{
            indexShow: true,//是否显示索引
            columns: [
            {
                label: '会员昵称',
                prop: 'memberName',
                width: '30%',
                align: 'center'
            },
            {
                label: '消费金额',
                prop: 'amountReceived',
                width: '30%',
                align: 'center'
            },
        ],
            url: api.report.memberRankCasher
          },
        storeMemberTable:{
            indexShow: false,//是否显示索引
            columns: [
            {
                label: '门店',
                prop: 'storeName',
                width: '100',
                align: 'center'
            },
            {
                label: '会员总数',
                prop: 'memberNum',
                width: '80',
                align: 'center'
            },
             {
                label: '新增人数',
                prop: 'addMemberNum',
                width: '80',
                align: 'center'
            },
             {
                label: '会员消费总数',
                prop: 'amountReceived',
                width: '80',
                align: 'center'
            },
            ],
            url: api.report.memberStore,
            param:this.$nextTick(()=>{
                 this.$refs["storeMember"].searchSubmit(this.param)
            })
          },
         payNumberTable:{
            indexShow: true,//是否显示索引
            columns: [
            {
                label: '会员昵称',
                prop: 'memberName',
                width: '30%',
                align: 'center'
            },
            {
                label: '充值金额',
                prop: 'depositMoney',
                width: '30%',
                align: 'center'
            },
            ],
            url: api.report.memberRecharge
          },
        memberSearchOptions:{
               simple: [
            {
              label: '',
              prop: 'CreateDttm',
              type: 'dateTimeRangeButton',
              dateType: "datetime",
              rangeButton:[{label:'今天',value:1,dateType:10},{label:'昨天',value:2,dateType:10},{label:'本周',value:4,dateType:20},{label:'本月',value:6,dateType:20}],
              span: 24,
            },
                ]
          },
        goodsRankSearchOptions:{
                simple: [
                    {
                    label: '',
                    prop: 'CreateDttm',
                    type: 'dateTimeRangeButton',
                    dateType: "datetime",
                    rangeButton:[{label:'今天',value:1},{label:'昨天',value:2},{label:'本周',value:4},{label:'本月',value:6}],
                    span: 24
                    },
                ]
          },
        apersonTableOptions: {
                indexShow:false,
                columns: [
                { label: "区间", prop: "goodsName", align: "center" },
                { label: "人数", prop: "allSum", align: "center" },
                 { label: "占比", prop: "allSum", align: "center" },
                ],
            },
        amoneyTableOptions:{
                 indexShow:false,
                columns: [
                { label: "区间", prop: "goodsName", align: "center" },
                { label: "金额", prop: "allSum", align: "center" },
                 { label: "占比", prop: "allSum", align: "center" },
                ],
            },
        spersonTableOptions: {
                indexShow:false,
                columns: [
                { label: "性别", prop: "goodsName", align: "center" },
                { label: "人数", prop: "allSum", align: "center" },
                 { label: "占比", prop: "allSum", align: "center" },
                ],
            },
        smoneyTableOptions:{
                 indexShow:false,
                    columns: [
                    { label: "性别", prop: "goodsName", align: "center" },
                    { label: "金额", prop: "allSum", align: "center" },
                    { label: "占比", prop: "allSum", align: "center" },
                ],
            }
         }
  },
  methods:{
      //会员概况
      getMemberData(param){
        this.$axios.fetchPost(api.report.memberDetailEcharts,param).then(data=>{
            if(data.code==200){
                let memberdata= document.querySelectorAll(".member-detail .sale-data h3");
                let memberNum=document.querySelectorAll(".progressbar .progressbar-top span");
                let yearInYear=document.querySelectorAll(".progressbar .progressbar-top p");
                let memberPercentage=document.querySelectorAll(".progressbar .el-progress .el-progress-bar__inner");
                let percentageText=document.querySelectorAll(".progressbar .el-progress .el-progress__text")
                 for(let i=0;i<memberdata.length;i++){
                      memberdata[0].innerHTML =data.data.amountReceived;
                      memberdata[1].innerHTML =data.data.orderNum;
                      memberdata[2].innerHTML =data.data.depositMoney;
                      memberdata[3].innerHTML =data.data.unitPrice;
                  }
                for(let j=0;j<memberNum.length;j++){
                    memberNum[0].innerHTML=data.data.newAmountReceived;
                    memberNum[1].innerHTML=data.data.oldAmountReceived;
                    memberNum[2].innerHTML=`环比：${data.data.surroundAmountReceived}`;
                    memberNum[3].innerHTML=data.data.newOrderNum;
                    memberNum[4].innerHTML=data.data.oldOrderNum;
                    memberNum[5].innerHTML=`环比：${data.data.surroundOrderNum}`;
                    memberNum[6].innerHTML=data.data.newDepositMoney;
                    memberNum[7].innerHTML=data.data.oldDepositMoney;
                    memberNum[8].innerHTML=`环比：${data.data.surroundDepositMoney}`;
                    memberNum[9].innerHTML=data.data.newUnitPrice;
                    memberNum[10].innerHTML=data.data.oldUnitPrice;
                    memberNum[11].innerHTML=`环比：${data.data.surroundUnitPrice}`;
                }
                for(let k=0;k<yearInYear.length;k++){
                    yearInYear[2].innerHTML=`同比：${data.data.sameAmountReceived}`;
                    yearInYear[5].innerHTML=`同比：${data.data.sameOrderNum}`;
                    yearInYear[8].innerHTML=`同比：${data.data.sameDepositMoney}`;
                    yearInYear[11].innerHTML=`同比：${data.data.sameUnitPrice}`;
                }
                for(let q=0;q<memberPercentage.length;q++){
                       memberPercentage[0].style.width = `${(data.data.newAmountReceived)/(data.data.amountReceived)*100}%`;
                       memberPercentage[1].style.width = `${(data.data.oldAmountReceived)/(data.data.amountReceived)*100}%`;
                       memberPercentage[2].style.width = `${(data.data.newOrderNum)/(data.data.orderNum)*100}%`;
                       memberPercentage[3].style.width = `${(data.data.oldOrderNum)/(data.data.orderNum)*100}%`;
                       memberPercentage[4].style.width = `${(data.data.newDepositMoney)/(data.data.depositMoney)*100}%`;
                       memberPercentage[5].style.width = `${(data.data.oldDepositMoney)/(data.data.depositMoney)*100}%`;
                       memberPercentage[6].style.width = `${(data.data.newUnitPrice)/(data.data.unitPrice)*100}%`;
                       memberPercentage[7].style.width = `${(data.data.oldUnitPrice)/(data.data.unitPrice)*100}%`;
                }
                for(let w=0;w<percentageText.length;w++){
                     if(data.data.amountReceived==0||data.data.orderNum==0||data.data.depositMoney==0||data.data.unitPrice==0){
                         return
                     }
                   percentageText[0].innerHTML =`${((data.data.newAmountReceived)/(data.data.amountReceived)*100).toFixed(2)}%`;
                   percentageText[1].innerHTML =`${((data.data.oldAmountReceived)/(data.data.amountReceived)*100).toFixed(2)}%`;
                   percentageText[2].innerHTML = `${((data.data.newOrderNum)/(data.data.orderNum)*100).toFixed(2)}%`;
                   percentageText[3].innerHTML = `${((data.data.oldOrderNum)/(data.data.orderNum)*100).toFixed(2)}%`;
                   percentageText[4].innerHTML = `${((data.data.newDepositMoney)/(data.data.depositMoney)*100).toFixed(2)}%`;
                   percentageText[5].innerHTML = `${((data.data.oldDepositMoney)/(data.data.depositMoney)*100).toFixed(2)}%`;
                   percentageText[6].innerHTML = `${((data.data.newUnitPrice)/(data.data.unitPrice)*100).toFixed(2)}%`;
                   percentageText[7].innerHTML = `${((data.data.oldUnitPrice)/(data.data.unitPrice)*100).toFixed(2)}%`;
                }
            }
        })
      },
      allStore(){
          let mes=[]
          mes.unshift({name:"全部门店",value:""});
          this.$axios.fetchPost(api.system.seStore+'/list').then(data=>{
            if(data.code===200){
            data.data.unshift({name:"全部门店",value:""});
            this.storeSearchOptions.simple.filter(item=>item.prop==="storeId")[0].data=data.data;
          }
          })
       },
      memberForword(param){
          this.$axios.fetchPost(api.report.memberForword,param).then(data=>{
              if(data.code==200){
                  let goodsdatabox=document.querySelectorAll('.goods-data-data div');
                  for(let i=0;i<goodsdatabox.length;i++){
                      goodsdatabox[0].innerHTML = data.data.memberNum
                      goodsdatabox[1].innerHTML = data.data.balance
                  }
              }
          })
      },
      getCustomerList(param){
            this.$axios.fetchPost(api.report.customePrice,param).then(data=>{
            if(data.code==200){
                if(data.data.length===0){
                    this.customerListEcharts.charsOption.title.text = "暂未查询到相关记录";
                    this.customerListEcharts.charsOption.title.top='center'
                    this.customerListEcharts.charsOption.title.left='center'
                    this.customerListEcharts.charsOption.series[0].data=[{}]
                }else{
                    this.customerListEcharts.charsOption.title.text ="";
                    this.customerListEcharts.charsOption.title.top=0
                    this.customerListEcharts.charsOption.title.left=0
                    this.customerListEcharts.charsOption.series[0].data = [];
                    data.data.map(item=>{
                       this.customerListEcharts.charsOption.series[0].data.push({
                            name:item.sectionData,
                            value:item.orderNum
                   });
                this.customerListEcharts.charsOption.legend.data.push(item.sectionData)
                  if ((data.data.orderNum = 0)) {
                this.customerListEcharts.charsOption.series[0].data = [];
              }
               })
                }
                 this.$nextTick(() => {
                this.$refs.customerListEcharts.drawpic();
            });
            }
          })
          
      },
      //等级分布统计
       getLevel(param){
          this.$axios.fetchPost(api.report.guestCategoryList,param).then(data=>{
            if(data.code==200){
                if(data.data.length==0){
                    this.levelEcharts.charsOption.title.text = "暂未查询到相关记录";
                    this.levelEcharts.charsOption.title.top='center'
                    this.levelEcharts.charsOption.title.left='center'
                    this.levelEcharts.charsOption.series[0].data = [];
                }else{
                    this.levelEcharts.charsOption.title.text ="";
                    this.levelEcharts.charsOption.title.top=0
                    this.levelEcharts.charsOption.title.left=0
                    this.levelEcharts.charsOption.series[0].data = [];
                    data.data.map(item=>{
                       this.levelEcharts.charsOption.series[0].data.push({
                            name:item.memberCategoryName,
                            value:item.amountReceived
                   });
                this.levelEcharts.charsOption.legend.data.push(item.memberCategoryName)
                  if ((data.data.amountReceived = 0)) {
                this.levelEcharts.charsOption.series[0].data = [];
              }
               })
                }
                   this.$nextTick(() => {
                      this.$refs.levelEcharts.drawpic();
            });
            }
          })
      },
      //会员消费次数
      getmConsumption(param){
          this.$axios.fetchPost(api.report.memberBuyNum,param).then(data=>{
              if(data.code==200){
                  this.mConsumptionEcharts.charsOption.xAxis[0].data = data.data.section
                  this.mConsumptionEcharts.charsOption.series[0].data = data.data.count
                    this.$nextTick(()=>{
              this.$refs.mConsumptionEcharts.drawpic();
          })
              }
          })
      },
      getIntensity(param){
          let $param=Object.assign({},param,{dateType:this.dateType||10})
             this.$axios.fetchPost(api.report.memberintensify,$param).then(data=>{
              if(data.code==200){
                  this.intensityEcharts.charsOption.xAxis[0].data = data.data.dateTime
                  this.intensityEcharts.charsOption.series[0].data = data.data.orderNum
                    this.$nextTick(()=>{
              this.$refs.intensityEcharts.drawpic();
          })
              }
          })
      },
    //   getAgePerson(){
    //        this.$nextTick(()=>{
    //           this.$refs.agePersonEcharts.drawpic();
    //       })
    //   },
    //    getAgeMoney(){
    //        this.$nextTick(()=>{
    //           this.$refs.ageMoneyEcharts.drawpic();
    //       })
    //   },
    //    getSexPerson(){
    //        this.$nextTick(()=>{
    //           this.$refs.sexPersonEcharts.drawpic();
    //       })
    //   },
    //    getSexMoney(){
    //        this.$nextTick(()=>{
    //           this.$refs.sexMoneyEcharts.drawpic();
    //       })
    //   },
      searchSubmit (result) {
        this.goodsParam= result
        this.getMemberData(result)
        this.memberForword(result)
        this.getLevel(result)
        this.getCustomerList(result)
        this.getmConsumption(result)
        this.getIntensity(result)
        this.$refs["saleNumber"].searchSubmit(result)
        this.$refs["storeMember"].searchSubmit(result)
      },

      clearSearch () {
        
      },
      goodsclearSearch(){
          
      },
      btnCommon (btnObj) {
        btnObj.callback && btnObj.callback();
      },
      goodsbtnCommon(btnObj){
          btnObj.callback && btnObj.callback();
      },
      memberbtnCommon(btnObj){
         btnObj.callback && btnObj.callback();
      },
      membersearchSubmit(param){
          let params = Object.assign({},this.param,param)
          this.getMemberData(params)
      }
      ,
      goodssearchSubmit(param){
          let dateType=this.$refs["goodsCumouser"].$refs["CreateDttm"][0].dateTypeActive
          if(dateType==1||dateType==2){
              this.dateType = 10
          }
          if(dateType==4||dateType==6){
              this.dateType =20
          }
          let params = Object.assign({},this.goodsParam,this.param,param)
         this.getLevel(params)
         this.getCustomerList(params)
         this.getmConsumption(params)
         this.getIntensity(params)
         this.$refs["storeMember"].searchSubmit(params)
      }
  }
}
</script>

<style scoped>
.goods-data{
    height: 100px;
    display: flex;
    width:60%;
    justify-content: space-between;
    margin-bottom: 20px;
}
.goods-data .goods-data-data{
    background: #fff;
    width:32%;
    border-radius: 14px;
    padding: 15px;
    box-shadow: 3px 3px 3px #e1e1e1;
    height: 111px;
}
.goods-data .goods-data-data>div{
    font-size: 28px;
    margin-bottom: 10px;
}
.echarbox{
    display: flex;
    flex: 2;
    flex-wrap: wrap;
    justify-content: space-between;
}
.echarbox .chartsbox-list{
    width: 49%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 3px 3px 3px #e5e5e5;
    margin-bottom: 10px;
    border: 1px solid #e5e5e5;
}
.echarbox .chartsbox-list>span{
    background: #f2f2f2;
    display: block;
    padding: 8px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    color: #333;
    font-weight: bold;
}
.echarbox .chartsbox-list>div{
    background: #fff;
    padding: 12px 12px 0 12px;
}
.echartMessage{
    display: flex;
    flex-wrap: wrap;
}
.echartMessage .echartMessage-list{
    width: 100%;
    background: #fff;
    border-radius: 8px;
    box-shadow: 3px 3px 3px #e5e5e5;
    margin-bottom: 10px;
    border: 1px solid #e5e5e5;
}
.echartMessage .echartMessage-list>span{
    background: #f2f2f2;
    display: block;
    padding: 8px;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    color: #333;
    font-weight: bold;
}
.echartMessage .echartMessage-list>div{
    background: #fff;
    padding: 12px;
}
.echarbox .data-range{
    border-radius: 8px;
}
.echarbox .data-range >>>.search-item{
  display: flex;
}
>>>.el-icon-search,>>>.el-icon-refresh{
    line-height: unset;
}
.echartMessage .echartMessage-list >>>.search-item{
    display: inline;
}
.echartMessage .memberArea{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.echartMessage .memberArea .memberArea-list{
    width: 47.5%;
    height: 300px;
    /* border: 1px solid blue; */
    padding: 0 0 10px 0;
}
/* .storeMember .table-box{
    width: 110%;
} */
.memberArea-list>span::before{
    content: "";
    display: inline-block;
    width: 10px;
    height: 10px;
    background: #5f58e6;
    border-radius: 50%;
    margin-right: 5px;
}
.storeMember{
    padding: 12px;
}
.agePerson{
    display: flex;
    justify-content: space-between;
}
.charts-box-agePerson{
    width: 49.5%;
     min-height: 220px;
}
.charts-box-ageMoney{
    height: 220px;
    width: calc(20vw);
}
.agePerson .list-template{
    width: 49.5%;
}
.echartsArea1{
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
}
.echartsArea1 .member-detail{
    width: 49.5%;
    height: 120px;
    border-radius: 8px;
    background: #f2f2f2;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.member-detail .sale-data{
    width: 35%;
    padding: 5px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-self: center;
}
.member-detail .progressbar{
    width: 65%;
    padding: 5px;
    box-sizing: border-box;
     border-left: 2px solid #ccc;
     display: flex;
     flex-direction: column;
    justify-content: space-between;
}
.progressbar >>>.el-progress-bar__outer {
    background: #ccc;
}
.progressbar-top{
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding-right: 10px;
    margin-bottom: 3px;
    box-sizing: border-box;
}
.progressbar >>>.el-progress{
   display: flex;
   align-items: center;
}
.chartsbox-list >>>.el-table__body-wrapper {
    max-height: 197px;
    overflow-y: auto;
    overflow-x:hidden;
}
.storeMember >>>.el-table__body-wrapper{
     max-height: 158px;
     overflow: auto;
}
</style>



// WEBPACK FOOTER //
// src/page/report/member/Preview.vue